import './innholdsvideo.module.css'
import { TilpassetInnholdsvideo } from './tilpasset-innholdsvideo.js'
import { DhArticlePlayerElement } from '@nrk/dh-article-player'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function hydrate(el, props) {
  if (typeof customElements.get('dhtv-tilpasset-innholdsvideo') === 'undefined') {
    customElements.define('dhtv-tilpasset-innholdsvideo', TilpassetInnholdsvideo)
  }

  if (typeof customElements.get('dhtv-article-player') === 'undefined') {
    customElements.define('dhtv-article-player', DhArticlePlayerElement)
  }
}
